export const ACTIVE = 1;
export const INACTIVE = 2;
export const UNUSED = 3;
export const PENDING = 4;
export const TO_ARCHIVE = 7;
export const ARCHIVE_DELETED = 8;
export const DELETED = 9;
